var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandlord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0996 3.84849C10.0996 3.53023 10.226 3.225 10.4511 2.99996L11.6511 1.79996C12.1197 1.33133 12.8795 1.33133 13.3481 1.79996L14.5481 2.99996C14.7732 3.225 14.8996 3.53023 14.8996 3.84849V4.55143L13.6996 5.75143L14.8996 6.95143V7.55143L13.6996 8.75143L14.8996 9.95143V12.3127C16.6777 13.1964 17.8996 15.0312 17.8996 17.1514C17.8996 20.1338 15.4819 22.5514 12.4996 22.5514C9.51727 22.5514 7.09961 20.1338 7.09961 17.1514C7.09961 15.0312 8.32155 13.1964 10.0996 12.3127V3.84849ZM12.4996 18.3514C11.8369 18.3514 11.2996 18.8887 11.2996 19.5514C11.2996 20.2142 11.8369 20.7514 12.4996 20.7514C13.1624 20.7514 13.6996 20.2142 13.6996 19.5514C13.6996 18.8887 13.1624 18.3514 12.4996 18.3514Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandlord);
export default __webpack_public_path__ + "static/media/landlord.35841dd7.svg";
export { ForwardRef as ReactComponent };